<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h4>Страны поставщиков</h4>
      </div>
      <div class="card-body">
        <table class="table mt-1 table-sm table-hover">
          <thead>
          <tr>
            <th>#</th>
            <th>Страна</th>
            <th>Доставка</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="c in sortArray(records, 'name')" :key="c.id">
            <td>{{ c.name }} ({{ c.title }})</td>
            <td>{{ c.currency }}</td>
            <td>{{ c.settings}}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      btnLoading: false,
      records: [],
      defaultSettings: {}
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRecords() {
      const {data} = await api.index('/new/suppliers/countries');
      if (data.success) {
        this.records = data.records;
      } else {
        toastr["warning"](data.message || 'Ошибка сервера');
      }
    }
  }
}

</script>
